module.exports = __webpack_public_path__ + "img/logarithmic_curve.42fc8fa0.png";